import { loadReportBuilder } from '../../reports/report-builder/report-builder.js';
import { SubTemplateMap } from './alert-trigger-cell.js';

angular.module('logbook')
	.directive('alertTriggerBuilder', ['$http', '$q', '$location', '$rootScope', 'reportMapping', '$filter', 'reportBuilderService', 'logService',
	function($http, $q, $location, $rootScope, reportMapping, $filter, reportBuilderService, logService)
	{
		return {
			restrict: 'E',
			template: require('./alert-trigger-builder.html'),
			scope: {
				onBind: '=',
				selectedLog: '=',
				template: '=',
				report: '='
			},

			link: {
				pre: function(scope)
				{
					scope.usersWithAccess = {};
					scope.usersWithAccess[scope.selectedLog.activeLogUser.id] = { id: 2 };
					
					if (!scope.report || !scope.report.id)
					{
						// set draft report
						scope.report = {
							"saveInProgress": true,
							"name": (scope.report && scope.report.name) ? scope.report.name : $filter('date')(new Date(), 'yyyy-MM-dd HH:mm'),
							"advancedMode": null,
							"primarySortDescending": null,
							"secondarySortDescending": null,
							"lastRun": null,
							"queryBuilderJson": null,
							"runOnLoad": null,
							"pageSize": null,
							"noteReturnLimit": null,
							"showObsoleteSegments": null,
							"autoRefreshSeconds": null,
							"defaultMenuBarItem": false,
							"defaultViewNotesFilter": false,
							"templateTrigger": false,
							"outputType": {
								"description": "Default",
								"name": "Default",
								"id": 1,
								"sortOrder": null,
								"_links": {
									"self": {
										"href": "http://174.131.178.229:45321/api/reportOutputTypes/1",
										"templated": true
									}
								}
							},
							"subTemplate": null,
							"template": null,
							"defaultRole": null,
							"logId": scope.selectedLog.id,
							"primarySort": null,
							"secondarySort": null,
							"users": []
						};
					}
					
					scope.alertTriggerContainer = {
						scope: undefined,
						defer: $q.defer(),
						
						bound: function (containerScope)
						{
							scope.alertTriggerContainer.scope = containerScope;
							
							if (scope.templateSegments)
								containerScope.templateSegments = scope.templateSegments;
							
							if (scope.subTemplate)
								containerScope.setSubTemplateIdFilter(scope.subTemplate.id);
							
							scope.alertTriggerContainer.defer.resolve(containerScope);
						},
						
						promise: function()
						{
							return scope.alertTriggerContainer.defer.promise;
						}
					};
					
					scope.$on('helpOpening', function (event, help)
					{
						help.setSection('template-alert-trigger-editor', 8);
					})
				},
				
				post: function(scope, element, attributes)
				{
					
					var reportBuilderDefer = $q.defer();
					scope.loadingBuilder = true;
					
					/**
					 * Setup Report Builder
					 */
					scope.$on('$includeContentLoaded', function (event)
					{
						var defer;
						scope.getReportData = (defer = $q.defer()).promise;
						
						var promises = {
							reportFields: $q(function(resolve)
							{
								if (scope.report.id)
									resolve($http.get('api/reportFields', {
										params: {
											'report': scope.report.id
										}
									}));
								else
									resolve({data: { _embedded: { reportFields: []}}})
							}),
							templateSegments: scope.report.template ?
								$http.get('api/templateSegments', {
									params: {
										'template': scope.report.template.id,
										'sort': 'sortOrder',
										'size': 10000
									}
								}) : null,
							reportViewEntries: $q(function(resolve)
							{
								if (scope.report.id)
									resolve($http.get('api/reportViewEntries', {
										params: {
											'report': scope.report.id,
											'sort': 'sortOrder'
										}
									}));
								else
									resolve(resolve({data: { _embedded: { reportViewEntries: []}}}))
							}),
							templates:
								$http.get('api/templates', {
									params: {
										logOrGlobal: scope.selectedLog.id,
										projection: 'templateProjectionWithSubTemplates'
									}
								})
						};
						
						scope.updateChangeStatus = function(status) {
							// var $saveButton = $('#save-button');
							// if (!scope.userHasEdit && !scope.userIsAdmin)
							// {
							// 	$saveButton.prop('disabled', true);
							// 	return;
							// }
							
							// scope.changesMade = status;
							// $saveButton.prop('disabled', !scope.changesMade);
						};
						
						scope.usersWithAccess = [];
						
						$q.all(promises).then(function(results) {
							scope.reportViewEntries = results.reportViewEntries.data._embedded.reportViewEntries;
							scope.subTemplate = scope.report.subTemplate;
							
							var reportData = {
								subTemplate: scope.report.subTemplate,
								reportFields: results.reportFields.data._embedded.reportFields,
								advancedMode: scope.report.advancedMode
							};
							
							if (results.templates)
								scope.templates = results.templates.data._embedded.templates;
							
							if (results.templateSegments) {
								scope.templateSegments = results.templateSegments.data._embedded.templateSegments;
								
								reportData.templateId = scope.report.template.id;
								reportData.templateName = scope.report.template.name;
								reportData.templateType = scope.report.template.templateType.name;
								reportData.templateSegments = scope.templateSegments.slice(0, scope.templateSegments.length);
							};
							
							defer.resolve(reportData);
						});
						
						defer.promise.then(function() {
							//overrides Report Builder Configuration Panel to not appear
							scope.hideConfigPanel = true;
							
							//sets report-builder to not animate up when loading is completed
							scope.noAnimate = true;
							
							scope.reportMapping = reportMapping;
							
							var $builder = loadReportBuilder(scope, $q, $location, $rootScope, $http, reportBuilderService, logService);

							scope.reportBuilder.initializedPromise().then(function()
							{
								reportBuilderDefer.resolve();
							});
							
							scope.reportBuilder.setBuilderName('Trigger Template');
							scope.alertTriggerContainer.promise()
								.then(function(containerScope)
								{
									containerScope.setTemplateSegments(scope.templateSegments)
										.then(function()
										{
											if (scope.subTemplate)
												containerScope.setSubTemplateIdFilter(scope.subTemplate);
										});
								})
							
						});
					});
					
					
					scope.saveReport = function()
					{
						var defer = $q.defer();
						$http.post('/api/reports', {
							'log': scope.selectedLog._links.self.href,
							'outputType': '/api/reportOutputTypes/1',
							'name': scope.report.name,
							saveInProgress: true,
							complexObject: (scope.report.complexObject) ? scope.report.complexObject._links.self.href : null,
							published: null,
							activeRevision: false,
							defaultMenuBarItem: false,
							templateTrigger: true,
							defaultViewNotesFilter: false
						})
							.then(function(result)
							{
								scope.report.id = result.data.id;
								scope.report._links = result.data._links;
								scope.report.complexObject = result.data._embedded.complexObject;
								try
								{
									scope.saveCriteria(function()
									{
										// Save Report Name
										$http.patch('/api/reports/' + scope.report.id, { name: scope.report.name })
											.then(function()
											{
												defer.resolve();
											}, function(error)
											{
												defer.reject(error)
											})
									}, function(error)
									{
										console.error(error);
										defer.reject(error === 'No Rules' ? '' : 'Query Builder Save Failure');
									});
								}
								catch(error)
								{
									console.error(error);
									defer.reject();
								}
							})
							.catch(function()
							{
								defer.reject();
							});
						
						return defer.promise;
					};
					
					/**
					 * Saves Trigger Report and all triggers
					 * @returns {Promise}
					 */
					scope.saveAll = function()
					{
						return scope.saveReport()
							.then(function()
							{
								if (!scope.alertTriggerContainer.scope)
									return $q.reject();
								
								return scope.alertTriggerContainer.scope.saveTriggers();
							})
							.then(function()
							{
								return $http.patch(scope.report._links.self.href, { saveInProgress: false, publish: true })
							})
					};
					
					scope.getTemplateSegments = function(template)
					{
						var defer = $q.defer();
						
						if (template || template.id >= 0)
							$http.get('/api/templateSegments?template=' + template.id)
								.then(function(results)
									{
										defer.resolve(scope.segments = results.data._embedded.templateSegments);
									},
									function(error)
									{
										defer.reject(error);
									});
						else
							defer.reject();
						
						return defer.promise;
					};
					
					scope.getTriggerSaveStatus = function()
					{
						return (scope.alertTriggerContainer.scope) ? scope.alertTriggerContainer.scope.getSaveReadyStatus() : false;
					};
					
					scope.getTemplateSegments(scope.template)
						.then(function(segments)
						{
							reportBuilderDefer.promise
								.then(function()
								{
									scope.loadingBuilder = false;
									scope.$watchCollection('templateSegments', function()
									{
										scope.alertTriggerContainer.promise().then(function(containerScope)
										{
											containerScope.setTemplateSegments(scope.templateSegments)
												.then(function()
												{
													if (scope.subTemplate)
														containerScope.setSubTemplateIdFilter(scope.subTemplate);
												});
										})
									});
									
									scope.$watch('subTemplate', function()
									{
										scope.alertTriggerContainer.promise()
											.then(function(containerScope) {	
												containerScope.setSubTemplateIdFilter((scope.subTemplate) ? scope.subTemplate : undefined)
											})
									});
									
									var templates = [new SubTemplateMap(segments).getReportBuilderFormatted(scope.template)];

									return scope.reportBuilder.loadReportLogTemplates(scope.template.id, templates, false).then(function() {
										if (!scope.report.id)
											scope.reportBuilder.refreshReportFilters();
									});
								})
								.then(function()
								{
									if (typeof scope.onBind === 'function')
										scope.onBind(scope);
								})
						})
				}
			}
		}
	}]);